// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'

import axios from 'axios'
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

import Vuex from 'vuex'
import store from './store/store'
Vue.use(Vuex)

import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
// Vue.use(videojs)
Vue.prototype.$video = videojs


Vue.config.productionTip = false

//全局注册组件
axios.defaults.withCredentials=true;
axios.interceptors.request.use(function (config) {
	let token = localStorage.getItem('authorization');
  let _this=this;
  config.headers['X-Requested-With'] = 'xmlhttprequest'
	if (token) {
    config.headers['Authorization'] = token;
	}
	return config;
})
Vue.prototype.$axios = axios;

// 登录验证
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requireAuth)){  // 判断该路由是否需要登录权限
    if (localStorage.authorization && localStorage.getItem('info')) {  // 判断当前的token是否存在
      if(to.meta.type && to.meta.type>JSON.parse(localStorage.getItem('info'))['type']){
          ElementUI.Message({
            message:'您的权限不足',
            type:'error'
          })
          window.history.go(-1)
      }else{
        if(JSON.parse(localStorage.getItem('info'))['info_status']['phone_status']!='1' || JSON.parse(localStorage.getItem('info'))['info_status']['mail_status']!='1'){
          next({
              path: '/infobinding'
          })
          router.replace()
        }else{
          next()
        }
      }
    }
    else {
      if(router.currentRoute.fullPath.indexOf('login')==-1){
        next({
            path: '/login',
            query: {redirect: to.fullPath}//登录成功后跳入浏览的当前页面
        })
        router.replace()
      }else{
        next()
      }
    }
  }
  else {
    next()
  }
});

axios.interceptors.response.use(
    response => {
      if(response.hasOwnProperty('data') && response.data.hasOwnProperty('data') && response.data.data.hasOwnProperty('token')){
        localStorage.setItem('authorization', response.data.data.token.token)
      }
      return response
    },
    err => {
    }
);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js